import React, { useMemo } from 'react';
import Tooltip from 'rc-tooltip';
import Grid from '@mui/material/Grid2';
import { styled } from '@mui/material/styles';
import { maxWidth } from '@mui/system';

export interface StyledInfoRowProps {
    namedItems?: { name: string }[];
    label: string;
    value?: string;
}

export const StyledInfoRow: React.FC<StyledInfoRowProps> = (
    props: StyledInfoRowProps
) => {
    const { namedItems, label, value } = props;
    const joinedNames = useMemo(() => {
        if (namedItems) {
            return joinNames(namedItems);
        }
        return value;
    }, [namedItems, value]);

    return (
        <StyledInfo container>
            <span className="label">{label}:</span>
            <Tooltip placement="top" overlay={joinedNames}>
                <span className="value">{joinedNames}</span>
            </Tooltip>
        </StyledInfo>
    );
};

const StyledInfo = styled(Grid)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    '& .label': {
        color: theme.palette.text.secondary,
        fontSize: '0.75rem',
    },
    '& .value': {
        display: 'block',
        fontWeight: 500,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: 100,
    },
}));

const joinNames = (items: { name: string }[]): string => {
    return items
        .filter((x) => x.name)
        .map((x) => x.name)
        .join(',');
};
